import { render, staticRenderFns } from "./NavigationQuota.vue?vue&type=template&id=26c061ec&scoped=true&"
import script from "./NavigationQuota.vue?vue&type=script&lang=js&"
export * from "./NavigationQuota.vue?vue&type=script&lang=js&"
import style0 from "./NavigationQuota.vue?vue&type=style&index=0&id=26c061ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c061ec",
  null
  
)

export default component.exports